import { HTTPService } from './HttpService';
import { AuthHTTPService } from './AuthHttpService';
import { AuthService } from './AuthService';
import { PhotoService } from './PhotoService';
import { TagService } from './TagService';
import { CommentService } from './CommentService';
import { RatingService } from './RatingService';
import { UserService } from './UserService';
import { AdminService } from './AdminService';

// Auth stack: AuthHTTPService <-> AuthService need each other after construction
export const authHttpService = new AuthHTTPService();
export const authService = new AuthService(authHttpService);
authHttpService.setAuthService(authService);

// Data stack: shares the same auth-refresh behavior via HTTPService
export const httpService = new HTTPService();
httpService.setAuthService(authService);

export const photoService = new PhotoService(httpService);
export const tagService = new TagService(httpService);
export const commentService = new CommentService(httpService);
export const ratingService = new RatingService(httpService);
export const userService = new UserService(httpService);
export const adminService = new AdminService(httpService);

export { HTTPService, AuthHTTPService, AuthService };
